import { TicketSeverity } from '@kfolks/types'
import { z } from 'zod'

export const paTaskWebhookSchema = z.object({
	dedupeKey: z.string().min(1),
	severity: z.enum(TicketSeverity),
	title: z.string().min(1),
	description: z.string().min(1),
	metadata: z.record(z.string(), z.unknown()).optional(),
})

export type PaTaskWebhookInput = z.infer<typeof paTaskWebhookSchema>
